import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import {BrowserRouter as Router, Routes, Route} from "react-router-dom";

import Main from "./components/Main/main";
import PreHome from "./components/PreHome/preHome";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
        <Routes>
          <Route exact path="/" element={<App customComponent={PreHome}/>}/>
          <Route exact path="/home" element={<App customComponent={Main}/>}/>
        </Routes>
      </Router>
  </React.StrictMode>
);
